export default "__VITE_ASSET__9466834a__"